'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function useUrl() {
  const [url, setUrl] = useState<string | null>(null);
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setUrl(new URL(pathname, window.location.href).toString());
    }
  }, [pathname]);

  return url;
}
